// extracted by mini-css-extract-plugin
export default {"root":"HighlightTilesContainer_root__ttfrM"};